import {CONTACTUS_REQUEST,CONTACTUS_SUCCESS,CONTACTUS_FAILURE } from '../Constants/ActionTypes';
 import { toast } from "react-toastify";
import * as API from '../API/api.js';

export const contactUs= (values )=> async dispatch => {
  try {
    dispatch({ type: CONTACTUS_REQUEST });
    const data = await API.contactUs(values);
    if (data) {
      dispatch({ type: CONTACTUS_SUCCESS, payload: data });
        // navigate('/')
        toast('Thank you for contacting us , We will get back to you soon...')
    }
  } catch (error) {
    toast('Unable to send information');
    dispatch({ type: CONTACTUS_FAILURE });
  }
};


